// @flow

import React from 'react';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';
import eventsApi from '../../../../network/api/eventsApi';
import type { ShoppingCenterTile } from '../../../../types/eventType';
import logo from '../../../../img/logo.svg';

type Props = {
  sc: ShoppingCenter,
  chooseShoppingCenter: Function,
  index: number,
  pcId: number,
}

type State = {
  scTile: ?ShoppingCenterTile,
}

class EventsShoppingCenterTile extends React.Component<Props, State> {
  state = {
    scTile: null,
  };

  fetchCountryTile() {
    eventsApi.fetchEventSCTile(this.props.sc.id)
      .then(response => !!response && response.json())
      .then((scTile) => {
        this.setState({ scTile });
        // Chargement automatique du premier centre aprés le chargement des centres d'un pays.
        if (this.props.index === 0) {
          this.props.chooseShoppingCenter(scTile.pcId);
        }
      });
  }

  componentDidMount() {
    this.fetchCountryTile();
  }

  componentDidUpdate(prevProps: Props, prevState: State, s: any) {
    if (prevProps.sc !== this.props.sc) {
      this.fetchCountryTile();
    }
  }

  render() {
    const { sc, chooseShoppingCenter, pcId } = this.props;
    const { scTile } = this.state;
    if (!scTile) {
      return false;
    }
    return (
      <div
        key={scTile.pcId}
        className={`event-sc ${scTile.haveNoEvent ? 'event-sc--disabled' : ''} ${(pcId === scTile.pcId) ? 'event-sc--choosen' : ''}`}
        onClick={() => !scTile.haveNoEvent ? chooseShoppingCenter(scTile.pcId) : console.log('This shopping center don\'t have events')}
      >
        <div className="event-sc-thumbnail">
          {
            scTile.thumbnail
              ? (
                <img src={scTile.thumbnail.thumbnail} alt={scTile.pcId} />
              ) : (
                <img src={logo} alt="URW" />
              )
          }
        </div>
        <div className="event-sc-name">
          {sc.name}
        </div>
      </div>
    );
  }
}

export default EventsShoppingCenterTile;
